import notifications from "../../assets/notification.png";
import user from "../../assets/user.png";
import caret from "../../assets/caret-down.png";
import { useState } from "react";
import profile from "../../assets/profile.png";
import setting from "../../assets/setting.png";
import logout from "../../assets/logout.png";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [dropdown, setDropdown] = useState(false);
  return (
    <div className="relative">
      <div className="flex items-center justify-between py-5 px-6 lg:px-16">
        <div>
          <h1 className="font-semibold text-3xl">Welcome, Femi</h1>
        </div>
        <div className="flex items-center space-x-5">
          <div className="px-3 border-r-2 border-border">
            <img src={notifications} alt="" className="w-6 h-7" />
          </div>
          <div
            onClick={() => setDropdown(!dropdown)}
            className="flex items-center space-x-3 hover:cursor-pointer"
          >
            <img src={user} alt="" className="w-12 h-12 rounded-full" />
            <img src={caret} alt="" className="w-3 h-3" />
          </div>
        </div>
      </div>
      {dropdown && (
        <div className="bg-white w-[200px] border absolute right-12 p-5 rounded-lg space-y-5">
          <Link to="/profile" className="flex items-center space-x-3">
            <img src={profile} alt="" className="w-4" />
            <h1 className="font-medium">Profile</h1>
          </Link>
          <div className="flex items-center space-x-2">
            <img src={setting} alt="" className="w-5" />
            <h1 className="font-medium">Settings</h1>
          </div>
          <Link to="/" className="flex items-center space-x-2">
            <img src={logout} alt="" className="w-5" />
            <h1 className="font-medium text-red-400">Log Out</h1>
          </Link>
        </div>
      )}
    </div>
  );
}
